export const oktaAuthConfig = {
    issuer: `${process.env.REACT_APP_OKTA_BASE_URL}`, // /oauth2/default
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: `${window.location.origin}/login/callback`,
    pkce: true,
};